// extracted by mini-css-extract-plugin
export var billingAddress = "_xl-g";
export var contactInfo = "_xl-d";
export var customerInfoContainer = "_xl-c";
export var customerInfoContainerMobile = "_xl-h";
export var customerInfoRow = "_xl-a";
export var customerInfoSection = "_xl-b";
export var fullWidthDividerMobile = "_xl-i";
export var imageContainer = "_xl-1";
export var paymentMethod = "_xl-e";
export var priceText = "_xl-6";
export var priceTextMobile = "_xl-7";
export var product = "_xl-0";
export var productImage = "_xl-2";
export var productInfo = "_xl-4";
export var productMobile = "_xl-9";
export var productTitle = "_xl-8";
export var quantityBadge = "_xl-3";
export var quantityText = "_xl-5";
export var shippingAddress = "_xl-f";